const rusToEngMap = {
    'ё':'`','й':'q','ц':'w','у':'e','к':'r','е':'t','н':'y','г':'u','ш':'i','щ':'o','з':'p','х':'[','ъ':']',
    'ф':'a','ы':'s','в':'d','а':'f','п':'g','р':'h','о':'j','л':'k','д':'l','ж':';','э':'\'',
    'я':'z','ч':'x','с':'c','м':'v','и':'b','т':'n','ь':'m','б':',','ю':'.','.':'/',
    'Ё':'`','Й':'Q','Ц':'W','У':'E','К':'R','Е':'T','Н':'Y','Г':'U','Ш':'I','Щ':'O','З':'P','Х':'[','Ъ':']',
    'Ф':'A','Ы':'S','В':'D','А':'F','П':'G','Р':'H','О':'J','Л':'K','Д':'L','Ж':';','Э':'\'',
    'Я':'Z','Ч':'X','С':'C','М':'V','И':'B','Т':'N','Ь':'M','Б':',','Ю':'.',',':'/'
};

const engToRusMap = {
    '`':'ё','q':'й','w':'ц','e':'у','r':'к','t':'е','y':'н','u':'г','i':'ш','o':'щ','p':'з','[':'х',']':'ъ',
    'a':'ф','s':'ы','d':'в','f':'а','g':'п','h':'р','j':'о','k':'л','l':'д',';':'ж','\'':'э',
    'z':'я','x':'ч','c':'с','v':'м','b':'и','n':'т','m':'ь',',':'б','.':'ю','/':'.',
    '~':'Ё','Q':'Й','W':'Ц','E':'У','R':'К','T':'Е','Y':'Н','U':'Г','I':'Ш','O':'Щ','P':'З','{':'Х','}':'Ъ',
    'A':'Ф','S':'Ы','D':'В','F':'А','G':'П','H':'Р','J':'О','K':'Л','L':'Д',':':'Ж','"':'Э',
    'Z':'Я','X':'Ч','C':'С','V':'М','B':'И','N':'Т','M':'Ь','<':'Б','>':'Ю','?':','
};

function convertRusToEng(str) {
    let result = '';
    for (let i = 0; i < str.length; i++) {
        result += rusToEngMap[str[i]] || str[i];
    }
    return result;
}

function convertEngToRus(str) {
    let result = '';
    for (let i = 0; i < str.length; i++) {
        result += engToRusMap[str[i]] || str[i];
    }
    return result;
}

function enableSelect2Search(selectEl, customOptions = {}) {
    if ($(selectEl).data('select2')) {
        $(selectEl).select2('destroy');
    }
    const options = Object.assign({
        minimumResultsForSearch: 0,
        width: '100%',
        matcher: defaultMatcher,
        language: {
            noResults: function() { return '---'; }
        }
    }, customOptions);
    $(selectEl).select2(options);

    $(selectEl).off('select2:open.iosFocus').on('select2:open.iosFocus', function() {
        setTimeout(function() {
            var $container = $(selectEl).next('.select2-container');
            var searchField = $container.find('.select2-search__field');
            if (searchField.length && !searchField.is(':focus')) {
                searchField.focus();
            }
        }, 100);
    });

    // Глобальный обработчик Backspace в фазе захвата — полностью очищает поле
    function onKeyDownCapture(e) {
        if (e.key !== 'Backspace') return;
        var $container = $(selectEl).next('.select2-container');
        if (!$container.length) return;
        var $search = $container.find('.select2-search__field');
        if ($search.length === 0) return;
        if ($search[0] !== document.activeElement) return;
        if ($search.val() && $search.val().length > 0) return;
        var selectedValues = $(selectEl).val() || [];
        if (selectedValues.length === 0) return;

        e.preventDefault();
        e.stopImmediatePropagation();
        $(selectEl).val(null).trigger('change');
        $search.val('').trigger('input');
    }

    document.removeEventListener('keydown', onKeyDownCapture, true);
    document.addEventListener('keydown', onKeyDownCapture, true);
    $(selectEl).one('select2:destroy', function() {
        document.removeEventListener('keydown', onKeyDownCapture, true);
    });

    function resetInputWidth() {
        var $container = $(selectEl).next('.select2-container');
        var $input = $container.find('.select2-search__field');
        var selected = ($(selectEl).val() || []).filter(function(v) { return v !== ''; });
        requestAnimationFrame(function() {
            if (selected.length > 0) {
                $input.css('width', '1px');
            } else {
                $input.css('width', '');
            }
        });
    }
    $(selectEl).off('change.inputWidthFix').on('change.inputWidthFix', resetInputWidth);
    resetInputWidth();
}

function initSingleAsMultiple(selectEl, options = {}) {
    const mergedOptions = Object.assign({
        multiple: true,
        placeholder: '--',
        allowClear: true,
        closeOnSelect: false,
    }, options);

    enableSelect2Search(selectEl, mergedOptions);

    $(selectEl).off('select2:select.singleLike').on('select2:select.singleLike', function(e) {
        $(this).val([e.params.data.id]).trigger('change');
        $(this).select2('close');
    });
}

function defaultMatcher(params, data) {
    if ($.trim(params.term) === '') return data;
    var term = params.term.toLowerCase();
    var text = data.text.toLowerCase();
    var cyrillic = (data.element && data.element.dataset.cyrillic || '').toLowerCase();

    if (text.indexOf(term) > -1 || cyrillic.indexOf(term) > -1) {
        return data;
    }

    var rusToEngTerm = convertRusToEng(term);
    if (rusToEngTerm !== term && text.indexOf(rusToEngTerm) > -1) {
        return data;
    }

    var engToRusTerm = convertEngToRus(term);
    if (engToRusTerm !== term && cyrillic.indexOf(engToRusTerm) > -1) {
        return data;
    }

    return null;
}

function yearMatcher(params, data) {
    if ($.trim(params.term) === '') return data;
    var term = params.term.trim();
    if (!/^\d+$/.test(term)) return null;
    if (data.text.indexOf(term) > -1) return data;
    return null;
}

function capacityMatcher(params, data) {
    if ($.trim(params.term) === '') return data;
    var term = params.term.trim().replace(',', '.');
    if (!/^[\d.]+$/.test(term)) return null;
    var normalizedText = data.text.replace(',', '.');
    if (normalizedText.indexOf(term) > -1) return data;
    return null;
}

const CONTROL_KEYS = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', 'Tab', 'Escape', 'Enter'];

function applySearchFieldValidator(selectEl, validatorFn) {
    $(selectEl).on('select2:open', function () {
        var $container = $(selectEl).next('.select2-container');
        var $search = $container.find('.select2-search__field');
        if (!$search.length) return;

        $search.off('keydown.searchValidation input.searchValidation');

        $search.on('keydown.searchValidation', function (e) {
            if (CONTROL_KEYS.indexOf(e.key) !== -1) return true;
            if (e.ctrlKey || e.metaKey || e.altKey) return true;

            var currentValue = this.value;
            var selectionStart = this.selectionStart;
            var selectionEnd = this.selectionEnd;
            var newValue = currentValue.slice(0, selectionStart) + e.key + currentValue.slice(selectionEnd);

            if (!validatorFn(newValue)) {
                e.preventDefault();
            }
        });

        $search.on('input.searchValidation', function () {
            var val = this.value;
            var corrected = validatorFn(val, true);
            if (corrected !== val) {
                this.value = corrected;
                this.setSelectionRange(corrected.length, corrected.length);
            }
        });
    });
}

function yearValidator(value, correct) {
    var cleaned = value.replace(/\D/g, '');
    if (cleaned.length > 4) {
        cleaned = cleaned.slice(0, 4);
    }
    if (correct) return cleaned;

    return /^\d{0,4}$/.test(value);
}

function capacityValidator(value, correct) {
    var cleaned = value.replace(/[^\d.,]/g, '');
    cleaned = cleaned.replace(/,/g, '.');
    var firstDotIndex = cleaned.indexOf('.');
    if (firstDotIndex !== -1) {
        cleaned = cleaned.substring(0, firstDotIndex + 1) + cleaned.substring(firstDotIndex + 1).replace(/\./g, '');
    }
    var parts = cleaned.split('.');
    var integerPart = parts[0] || '';
    var decimalPart = parts[1] || '';

    if (integerPart.length > 2) {
        integerPart = integerPart.slice(0, 2);
    }
    if (decimalPart.length > 1) {
        decimalPart = decimalPart.slice(0, 1);
    }

    var correctedValue = integerPart;
    if (decimalPart.length > 0) {
        correctedValue += '.' + decimalPart;
    } else if (parts.length > 1) {
        correctedValue += '.';
    }

    if (correctedValue === '.' || correctedValue.startsWith('.')) {
        correctedValue = '';
    }

    if (correct) return correctedValue;

    return /^$|^\d{1,2}(\.\d{0,1})?$/.test(correctedValue);
}

function restrictYearSearchInput(selectEl) {
    applySearchFieldValidator(selectEl, yearValidator);
}

function restrictCapacitySearchInput(selectEl) {
    applySearchFieldValidator(selectEl, capacityValidator);
}

export function initBrandModel(filterFormEl, apiLink) {
  const brandsEl = filterFormEl.querySelector('.js-filter-brands');
  const modelsEl = filterFormEl.querySelector('.js-filter-models');
  const masterId = '49';
  const groupIds = ['254', '255', '256'];

  initSingleAsMultiple(brandsEl, { placeholder: brandsEl.dataset.placeholder || '--' });
  if (!brandsEl.value || brandsEl.value === 'empty') {
    initSingleAsMultiple(modelsEl, { disabled: true, placeholder: modelsEl.dataset.placeholder || '--' });
  } else {
    modelsEl.removeAttribute('disabled');
  }

  const yearFromEl = filterFormEl.querySelector('select[name="year_from"]');
  const yearToEl = filterFormEl.querySelector('select[name="year_to"]');
  const capacityFromEl = filterFormEl.querySelector('select[name="capacity_from"]');
  const capacityToEl = filterFormEl.querySelector('select[name="capacity_to"]');

  if (yearFromEl) {
    initSingleAsMultiple(yearFromEl, { placeholder: yearFromEl.dataset.placeholder || '--', matcher: yearMatcher });
    restrictYearSearchInput(yearFromEl);
  }
  if (yearToEl) {
    initSingleAsMultiple(yearToEl, { placeholder: yearToEl.dataset.placeholder || '--', matcher: yearMatcher });
    restrictYearSearchInput(yearToEl);
  }
  if (capacityFromEl) {
    initSingleAsMultiple(capacityFromEl, { placeholder: capacityFromEl.dataset.placeholder || '--', matcher: capacityMatcher });
    restrictCapacitySearchInput(capacityFromEl);
  }
  if (capacityToEl) {
    initSingleAsMultiple(capacityToEl, { placeholder: capacityToEl.dataset.placeholder || '--', matcher: capacityMatcher });
    restrictCapacitySearchInput(capacityToEl);
  }

  const multiSelects = filterFormEl.querySelectorAll('select[multiple]');
  multiSelects.forEach(function(selectEl) {
    if (selectEl.classList.contains('js-filter-multiselect')) {
      const placeholder = selectEl.dataset.placeholder || '';
      const opts = {
        multiple: true,
        placeholder: placeholder,
        allowClear: true,
        width: '100%',
        matcher: function(params, data) {
          if ($.trim(params.term) === '') return data;
          if (data.text.toLowerCase().indexOf(params.term.toLowerCase()) > -1) {
            return data;
          }
          return null;
        }
      };
      if (selectEl.name === 'transmission[]') {
        opts.templateSelection = function(data) {
          if (!data.id) return data.text;
          var isMasterSelected = ($(selectEl).val() || []).indexOf(masterId) !== -1;
          if (isMasterSelected && groupIds.indexOf(data.id) !== -1) {
            return null;
          }
          return data.text;
        };
      }
      enableSelect2Search(selectEl, opts);
    }
  });

  // Связка КПП
  const transmissionSelect = filterFormEl.querySelector('select[name="transmission[]"]');
  if (transmissionSelect) {
    const $select = $(transmissionSelect);
    let ignoreTransmissionChange = false;

    function setTransmissionValues(values) {
      ignoreTransmissionChange = true;
      $select.val(values).trigger('change');
      ignoreTransmissionChange = false;
    }

    $select.on('change', function() {
      if (ignoreTransmissionChange) return;
      const currentVals = $select.val() || [];
      const isMasterSelected = currentVals.indexOf(masterId) !== -1;
      const prevMasterSelected = this._lastMasterState;

      if (prevMasterSelected !== undefined && prevMasterSelected !== isMasterSelected) {
        if (isMasterSelected) {
          const newVals = currentVals.slice();
          let changed = false;
          groupIds.forEach(function(id) {
            if (newVals.indexOf(id) === -1) {
              newVals.push(id);
              changed = true;
            }
          });
          if (changed) {
            setTransmissionValues(newVals);
          }
        } else {
          const newVals = currentVals.filter(function(id) { return groupIds.indexOf(id) === -1; });
          if (newVals.length !== currentVals.length) {
            setTransmissionValues(newVals);
          }
        }
      } else {
        if (isMasterSelected) {
          const allGroupSelected = groupIds.every(function(id) { return currentVals.indexOf(id) !== -1; });
          if (!allGroupSelected) {
            const newVals = currentVals.filter(function(id) { return id !== masterId; });
            setTransmissionValues(newVals);
          }
        }
      }
      this._lastMasterState = $select.val() ? ($select.val().indexOf(masterId) !== -1) : false;
    });

    const initialVals = $select.val() || [];
    const initialMasterSelected = initialVals.indexOf(masterId) !== -1;
    transmissionSelect._lastMasterState = initialMasterSelected;
    if (initialMasterSelected) {
      const newVals = initialVals.slice();
      let changed = false;
      groupIds.forEach(function(id) {
        if (newVals.indexOf(id) === -1) {
          newVals.push(id);
          changed = true;
        }
      });
      if (changed) {
        setTransmissionValues(newVals);
      }
    }
  }

  document.querySelector('.js-filter-reset')?.addEventListener('click', function() {
    setTimeout(function() {
      Array.from(modelsEl.options).forEach(function(option) {
        if (option.value) option.remove();
      });
      modelsEl.setAttribute('disabled', 'disabled');
      initSingleAsMultiple(modelsEl, { disabled: true });
    }, 0);
  });

  // Автоматическое исправление диапазонов
  filterFormEl.addEventListener('submit', function() {
    function fixRange(fromSelector, toSelector) {
      const fromEl = filterFormEl.querySelector(fromSelector);
      const toEl = filterFormEl.querySelector(toSelector);
      if (!fromEl || !toEl) return;
      const fromVal = $(fromEl).val()?.[0];
      const toVal = $(toEl).val()?.[0];
      if (fromVal && toVal) {
        const fromNum = parseFloat(fromVal);
        const toNum = parseFloat(toVal);
        if (!isNaN(fromNum) && !isNaN(toNum) && fromNum > toNum) {
          $(fromEl).val([toVal]).trigger('change');
          $(toEl).val([fromVal]).trigger('change');
        }
      }
    }
    fixRange('select[name="year_from"]', 'select[name="year_to"]');
    fixRange('select[name="capacity_from"]', 'select[name="capacity_to"]');
  });

  function loadModels() {
    var brandId = brandsEl.value;
    if (!brandId || brandId === 'empty') {
      Array.from(modelsEl.options).forEach(function(option) {
        if (option.value) option.remove();
      });
      modelsEl.setAttribute('disabled', 'disabled');
      initSingleAsMultiple(modelsEl, { disabled: true, placeholder: modelsEl.dataset.placeholder || '--' });
      return;
    }

    fetch(apiLink + '/getCategories&id=' + brandId)
      .then(function(response) {
        if (!response.ok) throw new Error('Network error');
        return response.text();
      })
      .then(function(text) {
        var jsonStart = text.indexOf('[');
        var jsonEnd = text.lastIndexOf(']');
        if (jsonStart === -1 || jsonEnd === -1) {
          throw new Error('No JSON found');
        }
        var jsonString = text.substring(jsonStart, jsonEnd + 1);
        var data = JSON.parse(jsonString);
        if (!Array.isArray(data)) throw new Error('Invalid format');
        Array.from(modelsEl.options).forEach(function(option) {
          if (option.value) option.remove();
        });
        data.forEach(function(model) {
          var option = document.createElement('option');
          option.value = modelsEl.dataset.value === 'name'
            ? model.full_name
            : model.category_id;
          option.textContent = model.name;
          option.dataset.cyrillic = model.cyrillic_name || '';
          modelsEl.appendChild(option);
        });
        modelsEl.removeAttribute('disabled');
        initSingleAsMultiple(modelsEl, { placeholder: modelsEl.dataset.placeholder || '--' });
        if (window.selectedModel) {
          $(modelsEl).val([window.selectedModel]).trigger('change');
        }
      })
      .catch(function(error) {
        console.error('Failed to load models:', error);
        Array.from(modelsEl.options).forEach(function(option) {
          if (option.value) option.remove();
        });
        modelsEl.setAttribute('disabled', 'disabled');
        initSingleAsMultiple(modelsEl, { disabled: true, placeholder: modelsEl.dataset.placeholder || '--' });
      });
  }

  $(brandsEl).on('change', loadModels);

  if (brandsEl.value && brandsEl.value !== 'empty') {
    loadModels();
  }
}